import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

export default function FAQ() {
  return (
    <div>
    
      <div id="team" className="container-fluid fq">
        <h2 className="main_banner-heading utilities__heading head_pt">
        Utilities for Holders & User Benefits 
        </h2>
        <p className="para-sub team_para faq__para">
        Little Billionaires offers the owner a multitude <br/> of advantages and benefits for holders 
        </p>
        <div className='row faq-row'>
          <div className='col-6 faq-column'>
            <div className='row dropdown_row'>

              <div className='col-2'>
              <img className='faq_imgs' alt="faq-imag" src={'images/new/7.1.png'}/>
              </div>
              <div className='col-10'>
              <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography> Staking <span className="utilities_arrow"><img src={'images/new/arroww.png'} alt="faq-imag"></img></span></Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography className='typo'>
          Each Little Billionaire holder can lock their NFTs in the internal staking program for any amount of
time. By staking your Little Billionaires you will be rewarded with $LITTLE tokens daily. Depending
on the rarity of your NFT, the staking rewards can be even higher than usual. Your NFT and your
rewards can be withdrawn from the staking program at any time
          </Typography>
        </AccordionDetails>
      </Accordion>
              </div>
              <div className='col-2'>
           
              </div>
            </div>
            <div className='row dropdown_row'>

              <div className='col-2'>
              <img className='faq_imgs' alt="faq-imag" src={'images/new/7.2.png'}/>
              </div>
              <div className='col-10'>
              <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>Get rewarded for Hodl $LITTLE <span className="utilities_arrow"><img src={'images/new/arroww.png'}  alt="faq-imag"></img></span></Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography className='typo'>
          The $LITTLE token is the internal currency of the Little Billionaires and will be the means of
payment for one of the largest decentralized marketplaces for gaming and digital art NFTs. By
staking your NFTs you will receive $LITTLE every day. If you hold these, you will be paid daily with
MATIC tokens on your wallet.
          </Typography>
        </AccordionDetails>
      </Accordion>
              </div>
              <div className='col-2'>
           
              </div>
            </div>
            <div className='row dropdown_row'>

              <div className='col-2'>
              <img className='faq_imgs' alt="faq-imag" src={'images/new/7.3.png'}/>
              </div>
              <div className='col-10'>
              <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>Little Billionaires Club <span className="utilities_arrow"><img src={'images/new/arroww.png'}  alt="faq-imag"></img></span></Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography className='typo'>
          As a Little Billionaire you get exclusive access to a unique club with internal events, exclusive
parties and VIP entry to selected clubs around the world. You will also become part of an internal
expert community. You are joining an exclusive group of people including global experts and
celebrities that share your passion for finance, business and art.
          </Typography>
        </AccordionDetails>
      </Accordion>
              </div>
              <div className='col-2'>
           
              </div>
            </div>
            <div className='row dropdown_row'>

              <div className='col-2'>
              <img className='faq_imgs' src={'images/new/7.4.png'} alt="faq-imag"/>
              </div>
              <div className='col-10'>
              <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>Explore Metaverse <span className="utilities_arrow"><img src={'images/new/arroww.png'} alt="faq-imag"></img></span></Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography className='typo'>
          Metaverse and virtual reality are without a doubt the future. Slip into your little billionaire in the
Metaverse and bring him to life. All Little Billionaires will be fully equipped for their use in the
Metaverse. You will be able to see your Little Billionaire as 3D avatar in games, movies and
several Metaverses.
          </Typography>
        </AccordionDetails>
      </Accordion>
              </div>
              <div className='col-2'>
           
              </div>
            </div>
    

     
      </div>
      


      <div className='col-6 faq-column'>

      <div className='row dropdown_row'>

              <div className='col-2'>
              <img className='faq_imgs' alt="faq-imag" src={'images/new/7.5.png'}/>
              </div>
              <div className='col-10'>
              <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>Digital Swap <span className="utilities_arrow"><img src={'images/new/arroww.png'} alt="faq-imag"></img></span></Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography className='typo'>
          As you already know, you can stake your Little Billionaires and earn $LITTLE on a daily basis. You
can exchange your $LITTLE for other cryptocurrencies such as MATIC on our digital exchange
and withdraw them to your chosen wallet. More exchangeable tokens will come in the future.
          </Typography>
        </AccordionDetails>
      </Accordion>
              </div>
              <div className='col-2'>
           
              </div>
            </div>
            <div className='row dropdown_row'>

              <div className='col-2'>
              <img className='faq_imgs' alt="faq-imag" src={'images/new/7.6.png'}/>
              </div>
              <div className='col-10'>
              <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>$LITTLE Airdrop <span className="utilities_arrow"><img src={'images/new/arroww.png'} alt="faq-imag"></img></span></Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography className='typo'>
          Each NFT holder will receive a $LITTLE Airdrop after minting their NFTs. For each NFT minted,
each user gets 1,000 $LITTLE credited to their balance.
          </Typography>
        </AccordionDetails>
      </Accordion>
              </div>
              <div className='col-2'>
           
              </div>
            </div>
            <div className='row dropdown_row'>

              <div className='col-2'>
              <img className='faq_imgs' src={'images/new/7.7.png'} alt="faq-imag"/>
              </div>
              <div className='col-10'>
              <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>IPO Whitelisting spot <span className="utilities_arrow"><img src={'images/new/arroww.png'}  alt="faq-imag"></img></span></Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Typography className='typo'>
          The $LITTLE token will be sold in an IPCO in Q2 2022 and made available to the public. As a Little
Billionaire NFT holder, you get the opportunity to get a discounted price before everyone else in
the presale and are guaranteed to be able to count to the first $LITTLE holders before it is listed
on the stock exchange.
          </Typography>
        </AccordionDetails>
      </Accordion>
              </div>
              <div className='col-2'>
           
              </div>
            </div>
    
            <div className='row dropdown_row'>

<div className='col-2'>
<img className='faq_imgs' alt="faq-imag" src={'images/new/7.8.png'}/>
</div>
<div className='col-10'>
<Accordion>
<AccordionSummary
expandIcon={<ExpandMoreIcon />}
aria-controls="panel1a-content"
id="panel1a-header"
>
<Typography>Take part in Giveaways <span className="utilities_arrow"><img src={'images/new/arroww.png'} alt="faq-imag"></img></span></Typography>
</AccordionSummary>
<AccordionDetails>
<Typography className='typo'>
Our Little Billionaires have a lot of giveaways planned for the community. Some of these are
exclusive to legendary holders. Most, however, are raffled among the entire community. As an
NFT holder, you automatically take part in these raffles
</Typography>
</AccordionDetails>
</Accordion>
</div>
<div className='col-2'>

</div>
</div>

     
  




      
    
      </div>
      </div>
      </div>
      </div>
  
  );
}
